class FostrAnnouncement extends HTMLElement {

  headerElPath = '.section-header sticky-header'

  constructor() {
    super()
  }

  hide() {
    this.classList.remove('is-visible')
  }

  show() {
    const headerEl = document.querySelector(this.headerElPath)
    if (!headerEl) return
    if(this.classList.contains('is-visible')) return

    this.style.top = this.calculateTopPosition(headerEl) + 'px'
    this.classList.add('is-visible')
    this.handleAutoHideDelay()
  }

  calculateTopPosition(headerEl) {
    return headerEl.getBoundingClientRect().height + headerEl.getBoundingClientRect().top
  }

  handleAutoHideDelay() {
    if (!this.dataset.autoHideDelay) return
    setTimeout(() => {
      this.hide()
    }, this.dataset.autoHideDelay)
  }
}

if (!customElements.get('fostr-announcement')) {
  customElements.define('fostr-announcement', FostrAnnouncement);
}
